var React = require('react');

function IconLeadClosedGoal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm-4.017-3.836L10 13.71l4.017 2.454-1.092-4.58L16.5 8.524l-4.692-.377L10 3.8 8.192 8.146 3.5 8.523l3.575 3.062-1.092 4.579z","fill":"#7A7370"}));
}

IconLeadClosedGoal.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = IconLeadClosedGoal;

IconLeadClosedGoal.default = IconLeadClosedGoal;
